import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgHugEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M12.75 40c-.41 0-.75-.34-.75-.75V24.4c0-3.08 2.07-6.2 6.03-6.2 1.62 0 3.01.48 4.35.95 1.33.46 2.59.9 4.07.9 2.57 0 4.18-.56 5.14-.9.19-.07.35-.12.49-.16 1.52-.47 2.9.04 3.59 1.32.77 1.44.1 3.14-1.02 3.83-.71.44-4.44 2.63-7.99 2.78-2.94.13-6.19-.44-8.39-.93-1.04-.23-1.56.09-1.79 1.11-.08.34-.09 1.2 1.51 1.73.18.06.37.13.59.2 2.13.75 6.09 2.15 12.1.38.4-.12.81.11.93.51s-.11.81-.51.93c-6.48 1.91-10.73.4-13.02-.41-.21-.07-.39-.14-.56-.19-2.27-.75-2.76-2.35-2.5-3.49.42-1.83 1.73-2.65 3.58-2.24 3.03.68 5.8.99 8 .9 3.18-.14 6.61-2.16 7.26-2.56.46-.28.89-1.1.49-1.84-.44-.82-1.24-.78-1.83-.6-.12.04-.27.09-.43.15-.98.34-2.81.98-5.63.98-1.74 0-3.17-.5-4.56-.99-1.29-.44-2.5-.86-3.87-.86-2.97 0-4.53 2.36-4.53 4.7v14.85c0 .41-.34.75-.75.75Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M34.47 40c-.41 0-.75-.34-.75-.75V26.8c0-.41.34-.75.75-.75s.75.34.75.75v12.45c0 .41-.33.75-.75.75ZM24.24 40c-.41 0-.75-.34-.75-.75V33.9c0-.41.34-.75.75-.75s.75.34.75.75v5.35c0 .41-.34.75-.75.75ZM27.33 16.68a4.34 4.34 0 0 1 0-8.68 4.34 4.34 0 0 1 0 8.68Zm0-7.18c-1.56 0-2.83 1.27-2.83 2.84 0 1.57 1.27 2.84 2.83 2.84s2.83-1.27 2.83-2.84c0-1.57-1.27-2.84-2.83-2.84Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M21.44 16.68a4.34 4.34 0 0 1 0-8.68c1.43 0 2.77.71 3.58 1.89.23.34.15.81-.19 1.04a.75.75 0 0 1-1.04-.19 2.834 2.834 0 0 0-5.17 1.61c0 1.57 1.27 2.84 2.83 2.84.83 0 1.62-.37 2.16-1.01.27-.32.74-.36 1.06-.09.32.27.36.74.09 1.06-.83.97-2.04 1.53-3.32 1.53Z",
    fill: "currentColor"
  }));
}

export { SvgHugEmojiSecondary as default };
